import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default class extends Controller {
  static values = { create: { type: Boolean, default: false } };

  connect() {
    this.select = new TomSelect(this.element, {
      create: this.createValue,
      sortField: { field: "text", direction: "asc" },
    });
  }

  disconnect() {
    this.select.destroy();
  }
}
